import './spinner.css'

const Spinner = () => {
  return (
    <div
      style={{
        display: 'flex',
        margin: '0 auto',
        marginTop: '250px',
        textAlign: 'center',
        flexDirection: 'column',
      }}
    >
      <div>
        <a
          href="https://makeresume.co"
          target="_blank"
          rel="noreferrer"
          title="Go to makeresume.co"
        >
          <img src="/logo.png" alt="makeresume.co" style={{ height: '36px', width: 'auto' }} />
        </a>
      </div>
      <div className="lds-facebook-big">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <span className="loading-message">loading</span>
      </div>
    </div>
  )
}

export default Spinner
